import React from 'react'

import { Redirect } from 'react-router-dom'

import { useSelector } from 'react-redux'
import { selectRoutes } from '@selectors'

import MatchRoute from '@components/match-route/match-route.component'

const ProtectedRoute = ({ children, ...props }) => {
  const { path } = props

  const routes = useSelector(selectRoutes)

  const { hasResources, hasTipping, permissionsSet, hasSafewalk } = useSelector(state => ({
    hasTipping: state.config.hasTipping,
    hasResources: state.config.hasResources,
    hasSafewalk: state.config.hasSafewalk,
    permissionsSet: state.config.permissionsSet
  }))

  if (!permissionsSet) return null

  const protectedRoutes = routes.filter(({ isProtected }) => isProtected)

  const isProtected = protectedRoutes.some(route => route.path === path)

  let canNavigate = true

  if (isProtected) {
    const { permission } = protectedRoutes.find(route => route.path === path)

    switch (permission) {
    case 'tips':
      canNavigate = hasTipping
      break
    case 'resources':
      canNavigate = hasResources
      break
    case 'safewalk':
      canNavigate = hasSafewalk
      break
    default:
      break
    }
  }

  return canNavigate ? (
    <MatchRoute
      {...props}
    >{children}
    </MatchRoute>
  ) : <Redirect to='/403' />
}

export default ProtectedRoute
